import { IRegion, RegionType } from '../interfaces/region.interface';

import { InitializeField } from './initialize-field.model';
import { Destination } from './destination.model';

export class RegionDetails extends InitializeField<IRegion> implements RegionType {
  name: string = '';
  id: string = '';

  destinations: Destination[] = [];

  // local filters
  destinationsSearchedAndSorted: Destination[] = [];

  protected excludedKeys: string[] = ['top_destinations'];

  constructor(data: Partial<IRegion> = {}) {
    super();
    this.initializeFields(data);

    this.destinations = this.destinationsSearchedAndSorted = this.mapToModelArray(
      data.top_destinations,
      Destination,
    );
  }

  public exist(): boolean {
    return !!this.id;
  }

  filterAndSortDestination(value: {
    searchInput: string;
    sortDir: string;
  }): void {
    const { searchInput, sortDir } = value;

    const filteredDestinations = this.destinations.filter(
      (attraction: any) =>
        attraction?.name &&
        attraction?.name?.toLowerCase().includes(searchInput?.toLowerCase()),
    );

    const sortedDestinations = filteredDestinations.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if (nameA < nameB) return sortDir === 'asc' ? -1 : 1;
      if (nameA > nameB) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });

    this.destinationsSearchedAndSorted = sortedDestinations;
  }

  protected getDefaultValue(key: string): any {
    switch (key) {
      case 'name':
      case 'id':
        return '';

      default:
        return null;
    }
  }
}
